import PropTypes from 'prop-types';
import React from 'react';
import { createStyles } from 'app/utils/css';

export const owlPath = `M1154.554 271.74l-53.73-199.542-106.128
           42.284c-71.68-43.388-155.958-69.23-246.29-70.85-84.612-1.518-164.45
           18.202-234.276 53.984l-104.54-50.786-70.818 203.65c-51.762
           73.934-82.85 162.806-84.532 259.198-4.842 262.294 208.86
           478.784 476.93 483.57 268.194 4.972 489.438-203.706
           494.224-465.978 1.612-93.53-24.54-181.178-70.84-255.53zM959.546
           598.602c-44.698-0.736-84.314-22.034-109.924-54.72l-105.184
           114.32-101.192-117.75c-26.728 31.79-66.986 51.694-111.65
           50.924-78.744-1.302-141.774-66.226-140.288-145.062 1.23-78.848
           66.192-141.692 145.052-140.368 78.884 1.358 141.668 66.354
           140.356 145.26-0.058 4.348-0.346 8.606-0.76 12.876l143.74
           2.416c-0.31-4.234-0.414-8.63-0.346-13.024 1.254-78.848
           66.226-141.702 144.994-140.358 78.882 1.312 141.774 66.25
           140.358 145.144-1.32 78.936-66.338 141.654-145.152
           140.342zM954.414 381.93c-17.948-0.242-32.664 13.99-33.032
           31.824-0.23 17.914 13.99 32.62 31.928 33.010 17.856 0.264
           32.562-14.014 32.884-31.906
           0.39-17.866-13.946-32.674-31.778-32.928zM527.842
           374.186c-17.856-0.288-32.642 13.946-32.952 31.882-0.264 17.914
           13.932 32.62 31.836 32.884 17.914 0.368 32.688-13.888
           32.974-31.79 0.298-17.914-13.932-32.618-31.86-32.974z`;

export default function IknowIcon({ size = '100%', colorful }) {
  return (
    <Styles>{css =>
      <svg width={size} height={size} viewBox="227 0 1024 1024" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
        <path
          className={colorful && css('colorful')}
          d={owlPath}
        />
      </svg>
    }</Styles>
  );
}

const Styles = createStyles({
  colorful: {
    fill: '#ff8b00',
  },
});

IknowIcon.propTypes = {
  size:     PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  colorful: PropTypes.bool,
};
